import React, { useState } from "react";
import {
  FloatingButton,
  FloatingButtonContainer,
} from "../Common/Ui/FloatingButtonHelper";
import CreateEnquiryModal from "./CreateEnquiryModal";
import { useAppDispatch, useAppSelector } from "../../store";
import { crmActions } from "../../slice/crm.slice";
import { CallbackRequestModal } from "./CallbackRequestModal";
import { EnumUserType } from "../../interfaces/userData.interface";

export const MainFloatingButton = () => {
  const dispatch = useAppDispatch();
  const [showCreateEnquiryModal, setShowCreateEnquiryModal] = useState(false);
  const [showCreateCallbackModal, setShowCreateCallbackModal] = useState(false);
  const userData = useAppSelector((state) => state.users.userData);

  const closeCreateEnquiryModal = () => {
    setShowCreateEnquiryModal(false);
  };

  const closeCallbackModal = () => {
    setShowCreateCallbackModal(false);
  };

  return (
    <>
      <div>
        <FloatingButtonContainer>
          {/* <Link>+</Link> */}

          {userData?.userType === EnumUserType.STAFF && (
            <>
              <FloatingButton
                onClick={() => {
                  setShowCreateCallbackModal(true);
                }}
              >
                <i className="fa-solid fa-phone text-white"></i>
              </FloatingButton>

              <FloatingButton
                onClick={() => {
                  setShowCreateEnquiryModal(true);
                }}
              >
                <i className="fa-solid fa-plus text-white"></i>
              </FloatingButton>
            </>
          )}

          {window.location.pathname === "/crm" && (
            <FloatingButton
              id="enquiryListFilter"
              onClick={() => {
                dispatch(crmActions.setShowFilterModal(true));
              }}
            >
              <i className="fa-solid fa-filter text-white"></i>
            </FloatingButton>
          )}

          <FloatingButton>
            <i className="fa-solid fa-ellipsis-vertical text-white"></i>
          </FloatingButton>
        </FloatingButtonContainer>
      </div>
      {showCreateEnquiryModal && (
        <CreateEnquiryModal
          onClose={closeCreateEnquiryModal}
          onSave={closeCreateEnquiryModal}
          showCreateEnquiry={showCreateEnquiryModal}
        />
      )}

      {showCreateCallbackModal && (
        <CallbackRequestModal
          onClose={closeCallbackModal}
          onSave={closeCallbackModal}
          show={showCreateCallbackModal}
        />
      )}
    </>
  );
};
